import { isEmpty } from 'lodash';

export default function parseGetApprovalStatusSuccess(data, oldState) {
  const state = oldState;
  // parse data from backend
  state.approvalStatus = {};
  if (typeof data === 'object' && !isEmpty(data) && !data.message) {
    state.approvalStatus = data;
    if (
      data.student.status === true &&
      data.counselor.status === true &&
      data.guardian.status === true
    ) {
      state.allApproved = true;
    }
  }

  return state;
}
